import dayjs, { Dayjs } from 'dayjs';

import { SubscriptionEndDatePeriod } from '../config';

// The presets look forward: the column holds the date a subscription runs out
// on, so "today" and "one week" are the ones about to expire. A window in the
// past is reachable through the custom range.
export const periodRange = (
  period: SubscriptionEndDatePeriod,
): { from?: Dayjs; to?: Dayjs } => {
  switch (period) {
    case 'today':
      return { from: dayjs().startOf('day'), to: dayjs().endOf('day') };
    case 'week':
      return {
        from: dayjs().startOf('day'),
        to: dayjs().add(7, 'day').endOf('day'),
      };
    default:
      return {};
  }
};
